export default function(src, id = "", isAsync = true, appendTo = null) {
  if (document.querySelectorAll('script[src="'+src+'"]').length) {
    return Promise.resolve()
  }
  let script = document.createElement('script')
  script.id = id
  if(isAsync) script.async = isAsync
  script.src = src

  let scriptDone = new Promise((res, rej) => {
    script.onload = res
    script.onerror = rej
  })

  if (typeof appendTo ==="string") {
    document.querySelector(appendTo).appendChild(script)
  } else {
    document.body.appendChild(script)
  }

  return scriptDone
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/getScript.js